import Vue from "vue";
import Vuex from "vuex";
import appConfig from "@/store/app-config";
import verticalMenu from "@/store/vertical-menu";
import app from "@/store/app/index.js";
Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
  },
  mutations: {
  },
  state: {
    defaultRows: 50,
  },
  strict: process.env.DEV,
});
